import React, { useEffect, useRef } from 'react';
import { Modal } from '../Modal/Modal';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { ActionMenuContent } from './components/ActionMenuContent';
import { ActionMenuTrigger } from './components/ActionMenuTrigger';
import { useActionMenu } from './hooks/useActionMenu';
import './ActionMenu.scss';

interface ActionMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
  actions?: {
    label: string;
    icon: React.ReactNode;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
  }[];
  itemName?: string;
}

export const ActionMenu = ({ onEdit, onDelete, actions, itemName = 'item' }: ActionMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const {
    openMenu,
    menuPosition,
    triggerRef,
    isConfirmationOpen,
    confirmationConfig,
    handleConfirm,
    closeConfirmation,
    handleMenuToggle,
    handleDelete,
    handleActionClick,
    handleClickOutside,
    canAccess,
  } = useActionMenu({ onDelete, itemName });

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  if (!canAccess) {
    return null;
  }

  return (
    <>
      <div
        ref={menuRef}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <ActionMenuTrigger triggerRef={triggerRef} onClick={handleMenuToggle} />
        <ActionMenuContent
          openMenu={openMenu}
          menuPosition={menuPosition}
          onEdit={onEdit}
          onDelete={onDelete ? handleDelete : undefined}
          actions={actions}
          handleMenuToggle={handleMenuToggle}
          handleActionClick={handleActionClick}
        />
        <Modal isOpen={isConfirmationOpen} onClose={closeConfirmation}>
          {confirmationConfig && (
            <ConfirmationModal
              {...confirmationConfig}
              onConfirm={handleConfirm}
              onCancel={closeConfirmation}
            />
          )}
        </Modal>
      </div>
    </>
  );
};
